import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SHOP_URL } from '../../data/ribbonData';

const B = 'https://customer-assets-cm19k8pv.emergentagent.net/job_1373bd47-7a24-47ca-adae-0f2fe2678f07/artifacts/';
const COLLAGE = [
  { src: `${B}8b11c3098e58787e_IMG_9892.JPG`, alt: 'Green ribbon collection' },
  { src: `${B}874f977eff558f7e_IMG_9893%202.JPG`, alt: 'Pink ribbon collection' },
  { src: `${B}5938b0be75d4882c_IMG_9895.JPG`, alt: 'Blue ribbon collection' },
  { src: `${B}266d3b1c0acaea8a_IMG_9896%202.JPG`, alt: 'Purple ribbon collection' },
];

const STATS = [
  { big: '2', small: 'widths: 1.5" & 5/8"' },
  { big: '10', small: 'yards per roll' },
  { big: '26', small: 'colors in each size' },
  { big: '100%', small: 'Native-owned' },
];

export const RibbonHero = () => (
  <section className="relative overflow-hidden" data-testid="ribbon-hero">
    <div className="absolute inset-0 rb-grid-bg pointer-events-none" />
    <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-[#ff6a00]/25 blur-[120px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20 pb-20 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 rb-rise">
        <p className="inline-flex items-center gap-2 rounded-full rb-glass px-4 py-1.5 rb-eyebrow mb-7">
          <span className="w-2 h-2 rounded-full bg-[#ff6a00] shadow-[0_0_10px_#ff6a00] animate-pulse" /> Basket pattern satin ribbon
        </p>
        <h1 className="rb-head text-6xl sm:text-7xl lg:text-8xl mb-7">
          <span className="rb-neon block">Rooted in tradition.</span>
          <span className="rb-grad block mt-2">Made for creation.</span>
        </h1>
        <p className="text-base sm:text-lg text-white/70 max-w-xl mb-9 leading-relaxed">
          Satin ribbon printed with patterns inspired by California Native basketry. Pick your width, pick your colors, and sew something that carries a story.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 mb-12">
          <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-shop-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-full rb-btn px-8 py-4 font-bold uppercase tracking-wider">
            Shop Native Ribbon <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </a>
          <a href="#shop-1-5" data-testid="hero-browse-colors-btn" className="inline-flex items-center justify-center rounded-full rb-btn-ghost px-8 py-4 font-bold uppercase tracking-wider">
            Browse all colors
          </a>
        </div>
        <ul className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="hero-stats">
          {STATS.map((s) => (
            <li key={s.small} className="rb-glass rounded-2xl p-4">
              <p className="rb-head text-3xl rb-grad">{s.big}</p>
              <p className="text-xs text-white/60 mt-1">{s.small}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-6 relative rb-rise" style={{ animationDelay: '150ms' }}>
        <div className="absolute inset-0 -m-6 rounded-[3rem] bg-gradient-to-br from-[#ff8a00]/40 to-[#ff2d00]/20 blur-3xl" />
        <div className="relative rb-glass rounded-[2.5rem] p-3 pb-9 grid grid-cols-2 gap-3" data-testid="hero-collage">
          {COLLAGE.map((c, i) => (
            <div key={c.alt} className={`overflow-hidden rounded-[1.75rem] aspect-square ${i % 2 ? 'translate-y-6' : ''}`}>
              <img src={c.src} alt={c.alt} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-testid={`hero-collage-img-${i}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
